var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7705 16.1491C21.1458 15.0566 20.401 14.0834 20.401 10.4111V9.65216C20.401 4.91611 16.6611 1.03489 12.0641 1.00021C12.0426 1.00011 12.0213 1 11.9998 1C9.76919 1.00295 7.63105 1.90598 6.05577 3.51045C4.48049 5.11492 3.5971 7.2894 3.59993 9.55555V10.4111C3.59993 14.0831 2.85472 15.0562 2.22968 16.1487C2.08039 16.4085 2.00117 16.7037 2.00001 17.0046C1.99886 17.3054 2.07581 17.6013 2.2231 17.8623C2.37039 18.1233 2.58283 18.3402 2.83897 18.4912C3.09512 18.6421 3.38593 18.7218 3.68206 18.7222H7.78929C7.78929 19.8568 8.23292 20.9448 9.02259 21.7471C9.81226 22.5493 10.8833 23 12 23C13.1168 23 14.1878 22.5493 14.9775 21.7471C15.7672 20.9448 16.2108 19.8568 16.2108 18.7222H20.318C20.6141 18.7218 20.9049 18.6422 21.161 18.4912C21.4171 18.3403 21.6295 18.1234 21.7768 17.8624C21.9241 17.6015 22.0011 17.3057 22 17.0049C21.9989 16.7041 21.9197 16.4089 21.7705 16.1491ZM12 21.2889C11.3302 21.2881 10.6881 21.0174 10.2144 20.5363C9.74078 20.0551 9.47436 19.4027 9.47359 18.7222H14.5265C14.5257 19.4027 14.2593 20.0551 13.7857 20.5363C13.312 21.0174 12.6699 21.2881 12 21.2889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon_bell.793427b51266c52598687d33f018e705.svg";
export { ForwardRef as ReactComponent };